import { analisi, user } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { DataGridTypes } from 'devextreme-react/cjs/data-grid'
import { EdmLiteral } from 'devextreme/common/data'

export const calculateAusiliariValue = (rowData: analisi) => {
  let ausiliari: string = ''
  rowData.tecnici_ausiliari?.map((tecnico: user) => {
    ausiliari = `${ausiliari + tecnico.fullname} `
  })
  return ausiliari.trim()
}

export const calculateAusiliariFilterExpression = (
  filterValue: any,
  selectedFilterOperation: string | null,
  target: string,
): string | (() => any) | Array<any> => {
  console.log('FLT', filterValue, selectedFilterOperation, target)

  if (target === 'filterBuilder' || target === 'filterRow') {
    switch (selectedFilterOperation) {
      case '=': {
        return [[new EdmLiteral(`tecnici_ausiliari/any(a: a/fullname eq '${filterValue}')`), '=', true]]
      }
      case '<>': {
        return [[new EdmLiteral(`tecnici_ausiliari/any(a: a/fullname eq '${filterValue}')`), '=', false]]
      }
      case 'contains':
      case 'startswith':
      case 'endswith': {
        return [
          [
            new EdmLiteral(`tecnici_ausiliari/any(a: ${selectedFilterOperation}(a/fullname, '${filterValue}'))`),
            '=',
            true,
          ],
        ]
      }
      default: {
        // caso notcontains
        return [[new EdmLiteral(`tecnici_ausiliari/any(a: contains(a/fullname, '${filterValue}'))`), '=', false]]
      }
    }
  } else if (target === 'search' || target === 'headerFilter') {
    return [[new EdmLiteral(`tecnici_ausiliari/any(a: contains(a/fullname, '${filterValue}'))`), '=', true]]
  }

  return filterValue
}

export const cellRenderAusiliari = (cellData: DataGridTypes.ColumnCellTemplateData) => {
  return (
    <>
      {cellData.data.tecnici_ausiliari.map((impiegato: user, index: number) => {
        return (
          <div className={`dx-tag-content custom-tag-padding`} key={index}>
            <span>{impiegato.fullname}</span>
          </div>
        )
      })}
    </>
  )
}
